<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col md="6" sm="12" class="mt-2 pb-4">
          <p class="reg-heading-tab">Director's Details</p>
          <p></p>
          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Full Name*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="First Name"
                    style="width:130px"
                    v-model="form.DirectorFirstName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-prepend>

                <b-form-input
                  type="text"
                  placeholder="Middle Name"
                  size="sm"
                  required
                  v-model="form.DirectorMiddleName"
                  :formatter="format"
                  lazy-formatter
                  style="width:75px"
                ></b-form-input>

                <b-input-group-append>
                  <b-form-input
                    type="text"
                    required
                    placeholder="Last Name"
                    size="sm"
                    style="width:130px"
                    v-model="form.DirectorLastName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group
              id="igrpDOB"
              horizontal
              label="Birth Date*"
              label-size="sm"
              label-for="ipDOB"
            >
              <date-picker
                id="ipDOB"
                v-model="DOB"
                :state="validateAge"
                format="DD-MM-YYYY"
                lang="en"
                required
                size="small"
              ></date-picker>
              <label class="ml-2">Age: {{form.Age}}</label>
            </b-form-group>
            <b-form-group id="grpAddress" horizontal label-size="sm" label="Address*">
              <b-form-input
                id="exampleInput2"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.DirectorAddress"
                required
                size="sm"
                placeholder="Address"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Designation*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.DirectorDesignation"
                required
                size="sm"
                placeholder="Designation"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Mobile*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="number"
                :state="mobileNumber"
                v-model="form.DirectorMobile"
                required
                size="sm"
                min="1000000000"
                max="9999999999"
                placeholder="10 digit Mobile Number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="igDirCast"
              horizontal
              label-cols="4"
              label="Caste*"
              label-size="sm"
              label-for="inpDirCast"
            >
              <b-form-select
                id="inpDirCast"
                :options="Caste"
                value-field="CasteID"
                text-field="CasteName"
                required
                size="sm"
                v-model="form.DirectorCaste"
              ></b-form-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="mt-2">
          <p>
            <span class="reg-heading-tab">Other Details</span>
          </p>

          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="DIN"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="text"
                v-model="form.DirectorDIN"
                size="sm"
                :formatter="format"
                lazy-formatter
                placeholder="DIN Number"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Email ID"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="email"
                v-model="form.DirectorEmail"
                size="sm"
                placeholder="Valid Email ID"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Adhar Card No.*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                :formatter="format"
                lazy-formatter
                size="sm"
                :state="validateAadhar"
                v-model="form.DirectorAadhar"
                required
                placeholder="Aadhar Number 12 digit"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Pancard No.*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="text"
                required
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.DirectorPAN"
                :state="validatePan"
                placeholder="PAN 10 digit"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="CIBIL Score"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                type="number"
                size="sm"
                :formatter="format"
                lazy-formatter
                v-model="form.DirectorCibil"
                required
                min="500"
                max="900"
                placeholder="CIBIL Score should be more than 500"
              ></b-form-input>
            </b-form-group>
            <b-row class="mt-2">
              <b-col>
                <b-button
                  variant="success"
                  style="margin-left:auto;margin-right:auto"
                  v-b-modal.modalDocs
                >Director Documents</b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2" v-if="!form.LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div class="mt-2 reg-details-wrap">
      <p
        class="reg-heading-tab"
      >Directors Details (Minimum Directors Requried: {{MinDirectors.directors}} / Minimum OBC Directors Required: {{MinDirectors.casteDirectors}})</p>
      <b-row align-h="center">
        <b-col>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="directors"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            style="font-size:12px"
          >
            <!-- <template slot="Gender" slot-scope="row">{{row.value?'Male':'Female'}}</template> -->
            <template v-slot:cell(show_details)="row">
              <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
              <b-button
                size="sm"
                @click.stop="row.toggleDetails"
                variant="link"
                class="m-0"
              >{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</b-button>
            </template>
            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                @click.stop="editMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Edit Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="deleteMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Delete Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-trash" style="font-size:16px;color:red"></i>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
    <b-modal id="modalConfirmdocument" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirmdocument" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCanceldocument" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
    <b-modal id="modalDocs" title="Documents for Director" size="lg" hide-footer>
      <!-- <pre>{{ directorInfo }}</pre> -->

      <b-card
        md="6"
        class="my-2"
        v-for="(item, index) in itemsDocuments"
        :key="item.document_name"
        border-variant="success"
      >
        <b-progress height="10px" :value="item.progressval" v-if="item.isLoading"></b-progress>
        <div class="row">
          <div class="col-md-4">
            <span style="font-size: 0.875rem;">{{item.lable_name}}</span>
            <b-form-input
              :id="'inp'+index"
              type="text"
              v-model="item.title"
              size="sm"
              v-if="item.showTitle"
              placeholder="Enter Document Name"
            ></b-form-input>
          </div>
          <div class="col-md-4">
            <b-form-file
              :ref="'fi'+index"
              @change="filechange($event, item, index)"
              accept=".jpg, .png, .gif, .pdf"
              size="sm"
              class="mt-3"
              v-if="item.file_name==''"
              plain
            ></b-form-file>
          </div>
          <div class="col-md-4" v-if="item.file_name!=''">
            <a :href="getImgUrl2(item.file_name)" target="_blank">
              <img :src="getImgUrl(item.file_name)" width="30px" class="img-fluid" />
            </a>
            <b-button
              size="sm"
              style="margin-left:0.5rem"
              @click.stop="deleteDocument2(index, item.file_name)"
              class="mr-1 pt-0 pb-0"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Delete Document"
            >
              <i class="fa fa-trash" style="font-size:16px;color:red"></i>
            </b-button>
          </div>
        </div>
        <!-- <div class="input-group my-2 px-2 py-2 bg-white shadow-sm" v-if="!item.isLoading">
          <input
            :id="'upload'+index"
            type="file"
            @change="filechange($event, item, index)"
            class="form-control border-0"
          />
          <label
            id="upload-label"
            :for="'upload'+index"
            class="font-weight-light text-muted"
          >{{item.lable_name}}</label>
          <div class="input-group-append">
            <label :for="'upload'+index" class="btn btn-light m-0 rounded-pill px-4">
              <b-icon icon="cloud-upload" aria-hidden="true"></b-icon>
              <small class="text-uppercase font-weight-bold text-muted">Choose file</small>
            </label>
          </div>
          <a :href="getImgUrl2(item.file_name)" target="_blank" class="mx-3">
            <img :src="getImgUrl(item.file_name)" style="width:30px" class="img-fluid" />
          </a>
        </div>-->
      </b-card>
    </b-modal>
  </b-container>
</template>

<script>
import { uploadPortalDocument } from "@/services/documentUpload";
import { protectedDocumentUrl } from "@/services/tenantDocuments";

import apis from "@/apis";
import lambda from "@/apis/lambda";
import axios from "axios";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
import store from '../../store';
var _currentDate = new Date();
export default {
  name: "FamilyDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      DOB: null,
      currentDate: _currentDate,
      directorInfo: "Documents",
      form: {
        GroupDirectorID: "00000000-0000-0000-0000-000000000000",
        DirectorFirstName: "",
        DirectorMiddleName: "",
        DirectorLastName: "",
        DirectorDOB: null,
        DirectorAadhar: "",
        DirectorAddress: null,
        DirectorDesignation: "",
        DirectorDIN: "",
        DirectorMobile: "",
        DirectorEmail: "",
        DirectorPAN: "",
        DirectorCibil: 0,
        GroupID: "00000000-0000-0000-0000-000000000000",
        UserID: "00000000-0000-0000-0000-000000000000",
        DirectorCaste: "00000000-0000-0000-0000-000000000000",
        DirectorIncome: 0,
        DirectorDocuments: {
          ResidentialProofPath: "",
          AddharCardPath: "",
          AddharCardBackPath: "",
          IncomeTaxApplication: "",
          PhotoPath: "",
          SignaturePath: "",
          IncomeCertificatePath: "",
          PancardPath: "",
          RationCardPath: "",
          RationCardLastPath: "",
          CasteCertificate: "",
          EduCertificate: "",
          BirthCertificate: "",
          DomicileCertificate: "",
          CibilProof: "",
          Other1: "",
          Other2: "",
          Other3: "",
          Other4: "",
          Other1Name: "",
          Other2Name: "",
          Other3Name: "",
          Other4Name: "",
          OtherName: ""
        }
      },
      directors: [],
      fields: [
        { key: "DirectorFirstName", label: "First Name", sortable: true },
        { key: "DirectorMiddleName", label: "Middle", sortable: false },
        { key: "DirectorLastName", label: "Last Name", sortable: true },
        { key: "DirectorAadhar", label: "Aadhar", sortable: false },
        { key: "DirectorPAN", label: "PAN" },
        { key: "DirectorCibil", label: "Cibil Score" },
        { key: "DirectorAddress", label: "Address", sortable: false },
        { key: "DirectorDesignation", label: "Designation", sortable: true },
        { key: "DirectorDIN", label: "DIN", sortable: false },
        { key: "DirectorMobile", label: "Mobile", sortable: false },
        { key: "DirectorEmail", label: "Email", sortable: false },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedNomineeId: "",
      saved: false,
      Caste: [],
      globalindex:0,
      fieldsDocuments: [
        { key: "lable_name", label: "Document Name" },
        { key: "action", label: "Upload/Replace" }
      ],
      itemsDocuments: [
      {
          document_name: "PhotoPath",
          lable_name: "Photo",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },  
      {
          document_name: "ResidentialProofPath",
          lable_name: "Address Proof",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "AddharCardPath",
          lable_name: "Adhar Card",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "AddharCardBackPath",
          lable_name: "Adhar Back Side",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        
        {
          document_name: "IncomeCertificatePath",
          lable_name: "Income Certificate",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "PancardPath",
          lable_name: "Pan Card",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        // {
        //   document_name: "RationCardPath",
        //   lable_name: "Ration Card First Page",
        //   file_name: "",
        //   isLoading: false,
        //   isSaving: false,
        //   progressval: 0,
        //   showTitle: false,
        //   title: ""
        // },
        // {
        //   document_name: "RationCardLastPath",
        //   lable_name: "Ration Card Last Page",
        //   file_name: "",
        //   isLoading: false,
        //   isSaving: false,
        //   progressval: 0,
        //   showTitle: false,
        //   title: ""
        // },
        {
          document_name: "CasteCertificate",
          lable_name: "Caste Certificate",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "BirthCertificate",
          lable_name: "Birth Certificate / School Leaving Certificate",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "DomicileCertificate",
          lable_name: "Domicile Certificate",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "CibilProof",
          lable_name: "CIBIL Score",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: false,
          title: ""
        },
        {
          document_name: "Other1",
          lable_name: "Other Document -1",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: true,
          title: ""
        },
        {
          document_name: "Other2",
          lable_name: "Other Document -2",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: true,
          title: ""
        },
        {
          document_name: "Other3",
          lable_name: "Other Document -3",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: true,
          title: ""
        },
        {
          document_name: "Other4",
          lable_name: "Other Document -4",
          file_name: "",
          isLoading: false,
          isSaving: false,
          progressval: 0,
          showTitle: true,
          title: ""
        }
      ]
    };
  },
  watch: {
    GroupID(newValue, oldValue) {
      this.getDirectors();
    }
  },
  computed: {
    MinDirectors() {
      return this.$store.getters.getDirectorNum;
    },
    GroupID() {
      return this.$store.getters.getGroupId;
    },
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        this.form.UserID = userinfo.UserID;
        return userinfo.LockProfile;
      } else {
        return false;
      }
    },
    mobileNumber() {
      if (this.form.DirectorMobile != null) {
        var phoneno = /^\d{10}$/;
        if (this.form.DirectorMobile.match(phoneno)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAadhar() {
      if (this.form.DirectorAadhar == null) {
        return false;
      }

      if (this.form.DirectorAadhar.length == 0) {
        return false;
      } else if (this.form.DirectorAadhar != null) {
        var adharformat = /^\d{12}$/;
        if (this.form.DirectorAadhar.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.form.DirectorPAN == null) {
        return false;
      }

      if (this.form.DirectorPAN.length == 0) {
        return false;
      } else if (this.form.DirectorPAN != null) {
        var format = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.DirectorPAN.match(format)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateCibil() {
      if (this.form.DirectorCibil == null) {
        return false;
      }

      if (this.form.DirectorCibil.length == 0) {
        return false;
      } else if (this.form.DirectorCibil != null) {
        if (this.form.DirectorCibil >= 500) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAge() {
      let age = this.calculateAge(this.DOB);
    
      if(this.DOB!=null)
  {
      this.form.Age = age;
      if (age < 18 || age >= 45) {
        return false;
      } else {
        return true;
      }
    }else this.form.Age=0;
  }
  },
  methods: {
    deleteDocument2(index, item) {
      this.globalindex=index;
      this.itemsDocuments[index].file_name = item;
      let info = "You want to delete record for:" + "\n" + item;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirmdocument");
    },
    modalCanceldocument() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirmdocument");
    },
    modalConfirmdocument() {
      //console.log(this.itemsDocuments[]);
      this.itemsDocuments[this.globalindex].file_name="";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      
      //this.form.LoginID = LoginID;
      //let promise = apis.saveLoanDocumentPath(this.form);

     
      this.$root.$emit("bv::hide::modal", "modalConfirmdocument");
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }

        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        var userinfo = this.$store.getters.loggedUser;
        var userid = userinfo.UserId;
        return (
          protectedDocumentUrl("https://aws.msobcfdc.in/S3BucketApril/" +
          userid.toLowerCase() +
          "/" +
          pic)
        );
      }
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n - 1;
    },
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      if (!this.validateAge) {
        this.alertText = "Age Criteria not fulfilled";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validateAadhar) {
        this.alertText = "Please verify the Aadhar number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validatePan) {
        this.alertText = "Please verify the PAN";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      // alert(this.form.DirectorDocuments);
      // for (var x in this.form.DirectorDocuments) {
      //   if (this.form.DirectorDocuments[x] == "" && !x.includes("Other")) {
      //     this.alertText = "Please Upload Document " + x;
      //     this.variant = "warning";
      //     this.showDismissibleAlert = true;
      //     this.isLoading = false;
      //     return;
      //   }
      // }

      this.isLoading = true;
      this.form.DirectorDOB = Formatter.convertDateFormatYMD(this.DOB);

      this.form.GroupID = this.$store.getters.getGroupId;
      if (this.form.GroupID == "00000000-0000-0000-0000-000000000000") {
        this.alertText = "Please Complete the Group Detail Page first.";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        this.form.UserID = userinfo.UserID;
      } else {
        return;
      }
      let promise = apis.saveDirector(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.getDirectors();
            this.onReset();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while Saving Data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.DirectorFirstName = "";
      this.form.DirectorMiddleName = "";
      this.form.DirectorLastName = "";
      this.form.DirectorAadhar = "";
      this.form.DirectorAddress = "";
      this.form.DirectorDesignation = "";
      this.form.DirectorDIN = "";
      this.form.DirectorMobile = "";
      this.form.DirectorEmail = "";
      this.form.DirectorPAN = "";
      this.form.DOB = null;
      this.DOB = null;
      this.form.DirectorCibil = 0;
      this.form.GroupDirectorID = "00000000-0000-0000-0000-000000000000";
      this.form.GroupID = "00000000-0000-0000-0000-000000000000";
      this.form.DirectorCaste = null;
      this.form.DirectorDocuments = {
        ResidentialProofPath: "",
        AddharCardPath: "",
        AddharCardBackPath: "",
        IncomeTaxApplication: "",
        PhotoPath: "",
        SignaturePath: "",
        IncomeCertificatePath: "",
        PancardPath: "",
        RationCardPath: "",
        RationCardLastPath: "",
        CasteCertificate: "",
        EduCertificate: "",
        BirthCertificate: "",
        DomicileCertificate: "",
        CibilProof: "",
        Other1: "",
        Other2: "",
        Other3: "",
        Other4: "",
        Other1Name: "",
        Other2Name: "",
        Other3Name: "",
        Other4Name: "",
        OtherName: ""
      };
      for (var i = 0; i < this.itemsDocuments.length; ++i) {
        this.itemsDocuments[i]["file_name"] = "";
      }
    },
    editMember(item, index, target) {
      this.onReset();
      this.form.DirectorFirstName = item.DirectorFirstName;
      this.form.DirectorMiddleName = item.DirectorMiddleName;
      this.form.DirectorLastName = item.DirectorLastName;
      this.form.DirectorAadhar = item.DirectorAadhar;
      this.form.DirectorAddress = item.DirectorAddress;
      this.form.DirectorDesignation = item.DirectorDesignation;
      this.form.DirectorDIN = item.DirectorDIN;
      this.form.DirectorMobile = item.DirectorMobile;
      this.form.DirectorEmail = item.DirectorEmail;
      this.form.DirectorPAN = item.DirectorPAN;
      this.form.DirectorCibil = item.DirectorCibil;
      this.form.GroupDirectorID = item.GroupDirectorID;
      this.DOB = item.DirectorDOB;
      this.form.DirectorCaste = item.DirectorCaste;
      //alert(JSON.stringify(item.DirectorDocuments));
      if (item.DirectorDocuments != null) {
        this.form.DirectorDocuments = item.DirectorDocuments;
      }
      var x;
      for (x in item.DirectorDocuments) {
        for (var i = 0; i < this.itemsDocuments.length; ++i) {
          if (this.itemsDocuments[i]["document_name"] == x) {
            this.itemsDocuments[i]["file_name"] = item.DirectorDocuments[x];
            break;
          }
        }
      }
    },
    getDirectors() {
      var userinfo = this.$store.getters.getGroupId;
      let promise = apis.ReadDirectors(userinfo);

      promise
        .then(response => {
          if (response.status == 200) {
            this.directors = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message || "Error while getting the details";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Delte Family Member post confirmation

    deleteMember(item, index, button) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.DirectorFirstName = item.DirectorFirstName;
      this.form.DirectorMiddleName = item.DirectorMiddleName;
      this.form.DirectorLastName = item.DirectorLastName;
      this.form.DirectorAadhar = item.DirectorAadhar;
      this.form.DirectorAddress = item.DirectorAddress;
      this.form.DirectorDesignation = item.DirectorDesignation;
      this.form.DirectorDIN = item.DirectorDIN;
      this.form.DirectorMobile = item.DirectorMobile;
      this.form.DirectorEmail = item.DirectorEmail;
      this.form.GroupDirectorID = item.GroupDirectorID;

      let info =
        "You want to delete record for:" + "\n" + item.DirectorFirstName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      //let promise = apis.deleteFamilyMember(this.form);
      let promise = apis.deleteDirector(this.form.GroupDirectorID);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getDirectors();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },
    getCaste() {
      let promiseA = apis.getCaste();

      promiseA
        .then(response => {
          if (response.status == 200) {
            //let rspns = response.body;
            this.Caste = response.body;
          } else {
            this.alertText = "Unable to get caste List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = "Unable to get caste List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    filechange(evt, item, index) {
      evt.preventDefault();
      this.itemsDocuments[index].progressval = 0;

      this.itemsDocuments[index].isLoading = true;

      if (!evt.target.files || evt.target.files.length == 0) return;

      var strings = evt.target.files[0].name.split(".");
      if (strings.length > 0) {
        var extn = strings[strings.length - 1].toLowerCase();
      }

      if (extn != "jpeg" && extn != "png" && extn != "jpg" && extn != "pdf") {
        alert("Wrong File Input");
        this.$refs[evt.target.id].reset();
        this.itemsDocuments[index].isLoading = false;
        this.itemsDocuments[index].progressval = 0;
        return;
      }


      let data = new FormData();
      var userinfo = this.$store.getters.loggedUser;
      var userid = userinfo.UserId;
      
      console.log(this.form.DirectorFirstName);

      var userid = userinfo.UserId;
      var filetype = evt.target.files[0].type;
      var _filepath=userid+"!!~~!!"+this.form.DirectorFirstName+"_"+ evt.target.files[0].name
        .replace("." + extn, Date.now() + "." + extn)
        .replace(/ /g, "_");

        var filepath =this.form.DirectorFirstName+"_"+ evt.target.files[0].name
        .replace("." + extn, Date.now() + "." + extn)
        .replace(/ /g, "_");

      //new code start
      //let promisefoto = lambda.getSignedURL(userid, filepath, filetype);

      let file = evt.target.files[0];

    data.append('file', file,_filepath);
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        "Access-Control-Allow-Origin": "*",
         "Authorization": "Bearer " + store.getters.authToken,
      }
    }
     
    uploadPortalDocument('https://api.msobcfdc.in/api/LoanDisbursement/UploadSactionLetter', data, config)
    .then(response => {
          let signedUrl = response;

          let x = this;
          var options = {
            onUploadProgress: function(progressEvent) {
              x.itemsDocuments[index].progressval = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": filetype
            }
          };
          if (response.status == 200) {
            this.itemsDocuments[index].file_name = filepath;
            this.itemsDocuments[index].dismissCountDown = this.dismissSecs;
            this.itemsDocuments[index].upload_replace = false;
            this.itemsDocuments[index].file_upload_status = 1;
            this.form.DirectorDocuments[item.document_name] = filepath;
            if (item.showTitle) {
              this.form.DirectorDocuments[
                item.document_name + "Name"
              ] = this.itemsDocuments[index].title;
            }

            //alert("File Uploaded Successfully");
          } else {
            alert("Error in uploading file");
            this.$refs[evt.target.id].reset();
          }
          this.itemsDocuments[index].isLoading = false;
          //return axios.put(signedUrl, evt.target.files[0], options);
        })
        .catch(err => {
          console.error(err);
          alert("Error");
          //this.$refs[evt.target.id].reset();
          this.itemsDocuments[index].isLoading = false;
          this.itemsDocuments[index].progressval = 0;
        
        });
          //console.log("Response", res);
          //alert(this.dismissSecs);
         
        ////////////end new code
        
    }
  },
  mounted() {
    this.getCaste();
    if (this.$store.getters.isLoggedIn) {
      this.getDirectors();
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
#upload {
  opacity: 0;
}

#upload-label {
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Directors.vue